import { render, staticRenderFns } from "./Second.vue?vue&type=template&id=63df628a&scoped=true"
import script from "./Second.vue?vue&type=script&lang=js"
export * from "./Second.vue?vue&type=script&lang=js"
import style0 from "./Second.vue?vue&type=style&index=0&id=63df628a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63df628a",
  null
  
)

export default component.exports